import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";

const baseUrl = process.env.REACT_APP_MARKETER_API_URL;

export const getMatrixComplianceApi = createAsyncThunk(
  "matrixCompliance/getMatrixComplianceApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/matrix-compliance`, payload)
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const saveMatrixComplianceApi = createAsyncThunk(
  "matrixCompliance/saveMatrixComplianceApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/matrix-compliance/save`, payload)
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendMatrixComplianceNotifApi = createAsyncThunk(
  "matrixCompliance/sendMatrixComplianceNotifApi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/api/matrix-compliance/send`, payload)
      );
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
